import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const Numbers = ({ numbers }) => {
  return (
    <Grid container spacing={2}>
      {numbers.map((item, i) => (
        <Grid key={i} item xs={12} md={4}>
          <Typography
            variant="h3"
            align={"center"}
            gutterBottom
            sx={{
              fontWeight: "medium",
            }}
          >
            {item.title}
          </Typography>
          <Typography color="text.secondary" align={"center"} component="p">
            {item.subtitle}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default Numbers;
